import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import * as CryptoJS from 'crypto-js';

import { Router, ActivatedRoute } from '@angular/router';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
// import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';

import { IssuesService } from '../../services/issues.service';
import { ProjectsService } from '../../../work/services/projects.service';
import { AlertManagerService } from '../../../../shared/services/alert-manager.service';
import { CookieManagerService } from '../../../../shared/services/cookie-manager.service';

import { Issue } from '../../../models/issue';

import { WorkConstants } from "../../../work/work.const";
import { IssueConstants } from "../../issues.const";

import { Constants } from '../../../../app.const';

@Component({
  selector: 'app-issue-creater',
  templateUrl: './issue-creater.component.html'
})
export class IssueCreaterComponent implements OnInit {

  @Input() projectId: number;
  @Input() issueId: number;
  @Input() isView: string;
  @Output() closeIssueCreater: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('attachFile') attachFile: any;
  @ViewChild('commentFile') commentFile: any;
  @ViewChild('editAttachFile') editAttachFile: any;

  currentProjectId: number;
  issue: any = {};
  issueForm: FormGroup;
  issueFormData: any = {};
  issueProjectData: any = {};
  isSubmitted: boolean = false;
  isCreate: boolean = true;
  isCommentEditor: Array<boolean> = [];
  isDeleteConfirm: Array<boolean> = [];
  trasparent: boolean = false;
  viewPermission:boolean = true

  currentAttachFile: any;
  currentEditAttachfile: any;
  currentCommentFile: any;
  currentEditCommentfile: any;
  
  comment: string;
  isDisabled: boolean = false;
  reporterd: any = {};
  currentDate: string;
  issueConstants: any = IssueConstants;
  workConstants: any = WorkConstants;

  attachments: any = [];
  comments: any = [];
  attachmentUrl: Array<string> = [];
  commentUrl: Array<string> = [];
  isChangeStatus: boolean = false;
  oldStatusValue: any;
  private constants = Constants;

  issuePickerOptions: IMyOptions = {
    dateFormat: this.constants.dateFormatDatepicker,
    selectionTxtFontSize: '14px',
    editableDateField: false,
    disableUntil: { year: 2016, month: 8, day: 10 },
  };

  // ccListOptions: IMultiSelectOption[] = [];
  ccListOptions: Array<any> = [];
  constructor(
    private formBuilder: FormBuilder,
    private issuesService: IssuesService,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private cookieManagerService: CookieManagerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    if(!this.isView){
      this.viewPermission = false;
    }
    this.initIssueFrom();
    this.getIssuesFormData();
    
  }

  initIssueFormData(){
    if (this.projectId) {
      this.issue.project_id = this.projectId;
      this.issueForm.controls['project_id'].disable();
    } else {
      this.setUrlParams();
    }
    if (this.issueId) {
      this.getIssue(this.issueId);
      this.isCreate = false;
      this.issueForm.controls['status'].enable();
    } else {
      this.isCreate = true;
      this.issue.status = 1;
      this.issueForm.controls['status'].disable();
    }
    this.isView ? 
      this.isView === "view" ? this.disabledForm() : this.router.navigate(['./mongoose/dashboard/sprintboard']) :
      this.isDisabled = false;
    this.getAuthUser();
    this.currentDate = new Date().toString();
  }

  initIssueFrom() {
    this.issueForm = this.formBuilder.group({
      project_id: ['', Validators.required,],
      title: ['', Validators.required],
      component_id: [ ],
      module_id: [],
      enviroment: [ ],
      description: [],
      version_id: ['', Validators.required],
      target_version_id: [],
      priority_id: [],
      severity_id: [],
      assignee: [], 
      related_to: [],
      cc_list: [],
      tags: [],
      comment: [],
      status: [ ],
      editDescription: []
    });
  }

  disabledForm(){
    this.isDisabled = true;
    this.issueForm.disable();
  }

  setUrlParams() {
    this.activatedRoute.params.subscribe(
      (param: any) => {
        this.issueId = param.issueId ? param.issueId : null;
        this.isView = param.isView ? param.isView : null;
      });
  }

  onChangeProject(event) {
    if (this.issueFormData.projects) {
      this.currentProjectId = parseInt(event);
      let issueProjectDatas = this.issueFormData.projects.filter(
        project => project.project_id === parseInt(event)
      );
      this.issueProjectData = issueProjectDatas[0];
    }
  }

  onChangeStatus(event){
    if(parseInt(this.issue.status) === this.oldStatusValue){
      this.isChangeStatus = false;
    }else{
      this.isChangeStatus = true;
    }
  }

  onClickCancel() {
    if (this.projectId) {
      this.closeIssueCreater.emit(true);
    } else {
      this.router.navigate(['./mongoose/issues/all']);
    }
  }

  openEditCommentForm(id?, attachment?){
    if(attachment){
      this.trasparent = true;
      this.isCommentEditor[attachment.id] = true;
    }else{
      this.trasparent = false;
      this.isCommentEditor[id] = false;
      this.getIssue(this.issueId);
    }
  }

  openDeleteConfirmFrom(attachment){
    this.trasparent = true;
    this.isDeleteConfirm[attachment.id] = true;
  }

  doConfirmeDelete(event, attachment){
    if(event){
      this.deleteIssueComment(attachment);
    }
    this.trasparent = false;
    this.isDeleteConfirm[attachment.id] = false;
  }

  getFileExtintion(fileName):string{
    if(fileName){
      let file = fileName.split('.');
      let extintion=file[file.length-1]
      return extintion;
    }
    return 'other';
  }

  createEditIssueObject() {
    let editIssueObj = new Issue();
    editIssueObj.project_id = this.issue.project_id;
    editIssueObj.title = this.issue.title;
    editIssueObj.component_id = this.issue.component_id ? this.issue.component_id : null;
    editIssueObj.module_id = this.issue.module_id ? this.issue.module_id : null;
    editIssueObj.enviroment = this.issue.enviroment;
    editIssueObj.description = this.issue.description;
    editIssueObj.version_id = this.issue.version_id ? this.issue.version_id : null;
    editIssueObj.target_version_id = this.issue.target_version_id ? this.issue.target_version_id : null;
    editIssueObj.priority_id = this.issue.priority_id ? this.issue.priority_id : null;
    editIssueObj.severity_id = this.issue.severity_id ? this.issue.severity_id : null;
    editIssueObj.assignee = this.issue.assignee ? this.issue.assignee : null;
    editIssueObj.related_to = this.issue.related_to ? this.issue.related_to : null;
    editIssueObj.cc_list = this.issue.cc_list;
    editIssueObj.tags = [];
    this.issue.tags.forEach(element => {
      editIssueObj.tags.push(element.value ? element.value : element);
    });
    this.createAttachments();
    editIssueObj.attachments = this.issue.attachments;
    editIssueObj.status = this.issue.status;
    return editIssueObj;
  }

  doCreateIssue() {
    this.isSubmitted = true;
    if (this.issueForm.valid) {
      if (this.isCreate) {
        this.createIssue();
      } else {
        this.editIssue();
      }
    }
  }

  createIssue() {
    this.initCreateObject();
    this.issuesService.createIssue(this.issue).subscribe(
      res => {
        this.alertService.success({ title: "SUCCESS", msg: "Successfully Created" });
        if (this.projectId) {
          this.closeIssueCreater.emit(true);
        } else {
          this.router.navigate(['./mongoose/issues/all']);
        }
      }
    );
  }

  initCreateObject(){
    this.issue.component_id = this.issue.component_id ? this.issue.component_id : null;
    this.issue.module_id = this.issue.module_id ? this.issue.module_id : null;
    this.issue.version_id = this.issue.version_id ? this.issue.version_id : null;
    this.issue.target_version_id = this.issue.target_version_id ? this.issue.target_version_id : null;
    this.issue.priority_id = this.issue.priority_id ? this.issue.priority_id : null;
    this.issue.severity_id = this.issue.severity_id ? this.issue.severity_id : null;
    this.issue.assignee = this.issue.assignee ? this.issue.assignee : null;
    this.issue.related_to = this.issue.related_to ? this.issue.related_to : null;
    this.createTags();
    this.createAttachments();
  }

  createTags(){
    let tags = [];
    if (this.issue.tags) {
      this.issue.tags.forEach(element => {
        tags.push(element.value);
      });
      this.issue.tags = tags;
    }
  }

  createAttachments(){
    let attachment = null;
    this.issue.attachments = [];
    if(this.currentAttachFile){
      attachment = {
        attachment: this.currentAttachFile.fileName,
        type: 1
      }
      this.issue.attachments.push(attachment);
    }
    let comment = null
    if(this.currentCommentFile || this.comment){
      comment = {
        attachment: this.currentCommentFile ? this.currentCommentFile.fileName : null,
        description: this.comment ? this.comment : null,
        type: 2
      }
      this.issue.attachments.push(comment);
    }
  }

  editIssue() {
    if(!this.isChangeStatus || (this.isChangeStatus && this.comment)){
      this.issuesService.editIssue(this.createEditIssueObject(), this.issue.id).subscribe(
        res => {
          this.getIssue(this.issue.id);
          this.comment = "";
          this.commentFile.nativeElement.value = "";
          this.attachFile.nativeElement.value = "";
          this.currentAttachFile = null;
          this.currentCommentFile = null;
          this.isChangeStatus = false;
          this.alertService.success({ title: "SUCCESS", msg: "Successfully Updated" });
        }
      );
    }else{
      this.alertService.error({ title: "ERROR", msg: "Please Enter Comment" });
    }
  }

  getIssuesFormData() {
    this.issuesService.getIssueFormData().subscribe(
      issueFormData => {
        this.issueFormData = issueFormData.data;
        this.initIssueFormData();
        if (this.projectId) {
          this.onChangeProject(this.projectId.toString());
        }
        if (this.issue.project_id) {
          this.onChangeProject(this.issue.project_id.toString());
        }
        this.setCCListOPtion(this.issueFormData.employees);
      }
    );
  }

  getIssue(issueId) {
    this.issuesService.getIssue(issueId).subscribe(
      res => {
        this.issue = res.data ? res.data : {};
        if(this.issue.tags){
          let tags = [];
          this.issue.tags.forEach(element => {
            tags.push(element.label);
          });
          this.issue.tags = tags;
        }
        this.oldStatusValue = this.issue.status;
        this.attachments = this.issue.attachments.filter(attachment => {return attachment.type===1;});
        this.comments = this.issue.attachments.filter(attachment => {return attachment.type===2;});
        this.setSelectedCCListOption(this.issue.cc_list);
        this.onChangeProject(this.issue.project_id ? this.issue.project_id.toString(): '');
      }
    );
  }

  getAuthUser(){
    let userToken = this.cookieManagerService.getCookie(WorkConstants.basicConstans.userToken, false);
    this.reporterd = JSON.parse(CryptoJS.AES.decrypt(userToken, WorkConstants.basicConstans.userKey).toString(CryptoJS.enc.Utf8));
  }

  setCCListOPtion(ccList:any) {
    let ccListOption = [];
    ccList.forEach(employee => {
      let object = {
        value: employee.emp_number,
        label: employee.emp_firstname+' '+employee.emp_lastname
      }
      ccListOption.push(object);
    });
    this.ccListOptions = ccListOption;
  }

  setSelectedCCListOption(ccList:any){
    let ccListOption = [];
    ccList.forEach(employee => {
      ccListOption.push(employee.emp_number);
    });
    this.issue.cc_list = ccListOption;
  }

  /**
   * upload attachment for issue
   */
  attachFileChanged(event, isNew) {
    if(event.target.files.length > 0){
      this.projectsService.uploadFile(event.target.files[0]).subscribe(
        file => {
          isNew ? this.currentAttachFile = file.data : this.currentEditAttachfile = file.data;
        }
      );
    }else{
      this.currentCommentFile = null;
    }
  }

  /**
   * upload comment attachment for issue
   */
  commentFileChanged(event, isNew) {
    if(event.target.files.length > 0){
      this.projectsService.uploadFile(event.target.files[0]).subscribe(
        file => {
          isNew ? this.currentCommentFile = file.data : this.currentEditCommentfile = file.data;
          this.isChangeStatus = true;
        }
      );
    }else{
      this.isChangeStatus = false;
      this.currentCommentFile = null;
    }
  }

  deleteFileAttachment(fileName, isComment){
    this.projectsService.removeFile(fileName.fileName).subscribe(
      file=> {
        if(isComment){
          this.currentCommentFile = null;
          this.commentFile.nativeElement.value = "";
          this.isChangeStatus = false;
        }else{
          this.currentAttachFile = null;
          this.attachFile.nativeElement.value = "";
        }
      }
    );
  }

  deleteIssueComment(attachment: any) {
    this.issuesService.deleteIssueComment(attachment.id).subscribe(
      res => {
        this.getIssue(this.issue.id);
        this.alertService.success({ title: "SUCCESS", msg: "Successfully Deleted" });
      }
    );
  }

  editIssueComment(attachment: any){
    let fileObject = {
      attachment: this.currentEditCommentfile ? this.currentEditCommentfile.fileName : 
        attachment.attachment ? attachment.attachment : null,
        description: attachment.description ? attachment.description : null
    }
    this.issuesService.editIssueComment(attachment.id, this.issue.id, fileObject).subscribe(
      res => {
        this.getIssue(this.issueId);
        this.trasparent = false;
        this.isCommentEditor[attachment.id] = false;
        this.editAttachFile.nativeElement.value = "";
        this.currentEditCommentfile = null;
        this.alertService.success({ title: "SUCCESS", msg: "Successfully Updated" });
      }
    );
  }

  getDownloadLink(attachment, isAttachment){
    let currentUrl = IssueConstants.apiUrl+'/files/get?f='+attachment.attachment;
    if(isAttachment){
      this.attachmentUrl[attachment.id] = currentUrl;
      return this.attachmentUrl[attachment.id];
    }else{
      this.commentUrl[attachment.id] = currentUrl;
      return this.commentUrl[attachment.id];
    }
  }

  errorHandler(attachment, event){
    let newUrl = IssueConstants.basicConstans.fileType[this.getFileExtintion(attachment.attachment)] ? 
      IssueConstants.basicConstans.fileType[this.getFileExtintion(attachment.attachment)] : 
      IssueConstants.basicConstans.fileType['other'];
      event.srcElement.setAttribute('src', newUrl);
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/issues/shared/issue-creater/issue-creater.component.ts